import React, { FC } from 'react';

import { SectionOneColumn } from '@/components/organisms/SectionOneColumn/render';

import block from './block.json';

/**
 * COMPONENT
 */
export const SectionCardsShop: FC<SectionOneColumnProps> & BlockConfigs = (
	props
) => {
	return <SectionOneColumn {...props} />;
};

SectionCardsShop.slug = block.slug;
SectionCardsShop.title = block.title;
